module.exports = __webpack_public_path__ + "img/vertical_5_1_6000.9d58fe64.png";